import { isBrowser } from "./Browser";
import { getProfile, saveProfile } from "../api";
import log from 'loglevel';


let profile = null;
let receiveEmail = null;

const isReceivingEmails = () => {
  return receiveEmail;
}

const setReceivingEmails = (shouldReceiveEmails) => {
  receiveEmail = shouldReceiveEmails;
};

const ensureProfileLoaded = () => {
  if (profile) {
    return;
  }
  if (isBrowser()) {
    const rawJsonProfile = JSON.parse(localStorage.getItem("profile")) || {};
    profile = {
      followed: new Set(rawJsonProfile.followed),
    };
  } else {
    profile = {};
  }
};

const getFollowed = () => {
  ensureProfileLoaded();
  const { followed = new Set() } = profile;
  return followed;
};

const getProfileObject = () => {
  return {
    followed: Array.from(getFollowed()),
  };
};

const getProfileAsJson = () => {
  return JSON.stringify({
    followed: Array.from(getFollowed()),
  });
};

const updateStorage = () => {
  if (!isBrowser()) {
    return;
  }
  localStorage.setItem("profile", getProfileAsJson());
};

const isFollowed = (exchange, symbol) => {
  const exchangeSymbol = `${exchange.toUpperCase()}_${symbol.toUpperCase()}`;
  return getFollowed().has(exchangeSymbol);
};

const saveAndUpdateServerFollowed = (newFollowed, sessionContext = {}) => {
  profile.followed = newFollowed;
  log.debug("Profile:", profile, sessionContext);
  updateStorage();
  if (sessionContext.session) {
    saveProfile({ data: getProfileObject(), context: { sessionContext } });
  }
};

const updateFollowed = (exchange, symbol, _followed, sessionContext = {}) => {
  const exchangeSymbol = `${exchange.toUpperCase()}_${symbol.toUpperCase()}`;
  const newFollowed = new Set(getFollowed());
  if (_followed) {
    newFollowed.add(exchangeSymbol);
  } else {
    newFollowed.delete(exchangeSymbol);
  }
  saveAndUpdateServerFollowed(newFollowed, sessionContext);
};

function eqSet(as, bs) {
  if (as.size !== bs.size) return false;
  for (var a of as) if (!bs.has(a)) return false;
  return true;
}

const syncProfile = (params) => {
  log.debug("syncProfile() params:", params);
  getProfile(params)
    .then(response => {
      const { receive_email } = response;
      receiveEmail = receive_email;
      log.debug("Profile response:", response);
      const serverFollowed = new Set(response.followed);
      const localFollowed = getFollowed();
      if (!eqSet(serverFollowed, localFollowed)) {
        log.debug("Server and local followed are out of sync, updating server...");
        const mergedFollowed = new Set();
        serverFollowed.forEach(sf => mergedFollowed.add(sf));
        localFollowed.forEach(lf => mergedFollowed.add(lf));
        // TODO: If local version has removed company, should it be removed from server?
        const { context = {} } = params;
        saveAndUpdateServerFollowed(mergedFollowed, context.sessionContext);
      } else {
        log.debug("Server and local followed are in sync, no server call needed.");
      }
    })
    .catch(err => {
      log.error("Error getting profile from server:", err);
    });
};

export {
  getFollowed,
  isFollowed,
  updateFollowed,
  syncProfile,
  isReceivingEmails,
  setReceivingEmails,
};

